import { AxiosRequestConfig } from 'axios';
import axiosInstance from '../axios';
import { API_BASE_URL } from '../../constants';
import { GET_EXPERIENCE_COMPANY_ENDPOINT } from './constants';

export class SearchAPI {
  searchServiceRoute = `${API_BASE_URL}/search`;
  config: AxiosRequestConfig = {};

  constructor() {
    this.config = { withCredentials: true };
  }

  getExperienceCompanies = async (searchQuery: string): Promise<any> => {
    const endpoint = `${this.searchServiceRoute}${GET_EXPERIENCE_COMPANY_ENDPOINT(searchQuery)}`;

    try {
      const result = await axiosInstance.get<any>(endpoint, {
        ...this.config,
      });

      return result.data.payload;
    } catch (e) {
      throw new Error('apiResponse.couldNotGetExperienceCompanies');
    }
  };
}
